import {
	GET_GLOBAL_LLM_CONFIGURATION,
	GET_GLOBAL_LLM_CONFIGURATION_SUCCESS,
	GET_GLOBAL_LLM_CONFIGURATION_FAIL,
	GET_GLOBAL_LLM_CONFIGURATION_RESET,
} from '../actions/getGlobalLLMConfigurationAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getGlobalLLMConfigurationReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_GLOBAL_LLM_CONFIGURATION:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_GLOBAL_LLM_CONFIGURATION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_GLOBAL_LLM_CONFIGURATION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_GLOBAL_LLM_CONFIGURATION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getGlobalLLMConfigurationReducer;

